export default __webpack_public_path__ + "static/arcanum-hero-0ec958fe7e828b499b5543e9ab95e63f.webp";